import { API_URL, CDN_URL } from 'constants';
export const URL = {
  AUTH: {
    PROVIDE_ACCOUNT: `${API_URL}auth/provide_account`,
    VERIFY_ACCOUNT: `${API_URL}auth/verify_account`,
    REMOVE_SESSION: `${API_URL}auth/remove_session/`
  },
  USER: {
    USER: `${API_URL}user`,
    CHANGE_NAME: `${API_URL}user/change_name`,
    ACCOUNT: `${API_URL}user/account`,
    VERIFY_ADD_ACCOUNT: `${API_URL}user/account/verify`,
    UPLOAD_AVATAR: `${API_URL}user/avatar`
  },
  PM: {
    CREATE: `${API_URL}pm/`
  },
  GROUP: {
    GROUPS: `${API_URL}group/`,
    JOIN: code => `${API_URL}group/${code ? code : 'empty'}/`,
    UPDATE: group_id => `${API_URL}group/${group_id}`,
    UPLOAD_AVATAR: group_id => `${API_URL}group/avatar/${group_id}`,
    USERS: group_id => `${API_URL}group/${group_id}/users`,
    USER: (group_id, user_id) => `${API_URL}group/${group_id}/user/${user_id}`,
    PERMISSIONS: group_id => `${API_URL}group/${group_id}/permissions`,
    LEAVE: group_id => `${API_URL}group/${group_id}/leave`,
    ADD_TASK: group_id => `${API_URL}group/${group_id}/task`,
    SUBMISSION: (group_id, task_id) => `${API_URL}group/${group_id}/submission/${task_id}`,
    REMOVE_TASK: (group_id, task_id) => `${API_URL}group/${group_id}/task/${task_id}`,
    UPDATE_TASK: (group_id, task_id) => `${API_URL}group/${group_id}/task/${task_id}`,
    CLOSE_GROUP: group_id => `${API_URL}group/${group_id}/close`,
    OPEN_GROUP: group_id => `${API_URL}group/${group_id}/open`,
    ADD_MATERIAL: group_id => `${API_URL}group/${group_id}/material`,
    REMOVE_MATERIAL: (group_id, upload_id) => `${API_URL}group/${group_id}/material/${upload_id}`,
    MAKE_ADMIN: group_id => `${API_URL}group/${group_id}/user/MAKE_ADMIN`,
    UNMAKE_ADMIN: group_id => `${API_URL}group/${group_id}/user/UNMAKE_ADMIN`,
    REMOVE_MEMBER: conv_id => `${API_URL}group/${conv_id}/user/REMOVE_MEMBER`,
    UNBLOCK_MEMBER: conv_id => `${API_URL}group/${conv_id}/user/UNBLOCK_MEMBER`,
    LEAVE_GROUP: conv_id => `${API_URL}group/${conv_id}/user/LEAVE_GROUP`
  },
  CONV: {
    DELETE_MSG: conv_id => `${API_URL}conv/${conv_id}/delete_msg`,
    PROCESS_MSG_UPLOAD: (conv_id, msg_id) => `${API_URL}conv/${conv_id}/process_msg_upload/${msg_id}`
  },
  DEFAULT_AVATAR: (user_id, file_id, type, size = 's') =>
    `${CDN_URL}${encodeURIComponent(`default_avatars/${type}/${size}/${file_id}.jpg`)}?alt=media`
};



// WEBPACK FOOTER //
// ./src/utils/url.js